import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '@/lib/cn';
import { Spinner } from './Spinner';
const variantClasses = {
    primary: 'bg-brand text-white hover:bg-brand/90 focus-visible:ring-brand disabled:bg-brand/50',
    secondary: 'bg-gray-100 text-gray-900 hover:bg-gray-200 focus-visible:ring-gray-400 dark:bg-gray-700 dark:text-gray-100 dark:hover:bg-gray-600',
    ghost: 'bg-transparent text-gray-700 hover:bg-gray-100 focus-visible:ring-gray-400 dark:text-gray-300 dark:hover:bg-gray-700',
    danger: 'bg-red-600 text-white hover:bg-red-700 focus-visible:ring-red-500 disabled:bg-red-400',
};
const sizeClasses = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-2 text-sm',
    lg: 'px-5 py-2.5 text-base',
};
export const Button = forwardRef(({ variant = 'primary', size = 'md', loading, disabled, children, className, ...props }, ref) => {
    return (_jsxs("button", { ref: ref, disabled: disabled || loading, className: cn('inline-flex items-center justify-center gap-2 rounded-lg font-medium transition-colors', 'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2', 'disabled:pointer-events-none disabled:opacity-60', variantClasses[variant], sizeClasses[size], className), ...props, children: [loading && _jsx(Spinner, { size: "sm" }), children] }));
});
Button.displayName = 'Button';
//# sourceMappingURL=Button.js.map